import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserTypeDtoModel } from '@heitown/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class UserTypeApiClient extends BaseCRUDApiClient<UserTypeDtoModel> {
  baseUrl = this.config.apiEndpoint + '/user-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
